export enum EReportCreationType {

    RapportPrelevement = 1,
    RapportEssai = 2, // Default repport
    RapportInterpretation = 3,
    SaisieMinvCE = 4,
    SoutienMinvCE = 5,
    SoutienDiat = 6,
    RapportEssaiLacPhyto = 7, // Specific report
    SaisieMPhytCE = 8,
    RapportPhytoIPLAC = 9,
    RapportInterpretationSynthese = 10
}
